// import $ from 'jquery';
import T from 'terrific';
import fancybox from '@fancyapps/fancybox'; // eslint-disable-line no-unused-vars

// Static resources
// Require all static files if they have no dedicated component
require('../../../../Assets/Media/loading.svg');

/**
 * Page module implementation.
 *
 * @author Daniel Koch
 * @namespace Tc.Module
 * @class Page
 * @extends Tc.Module
 */
T.Module.Page = T.createModule({
	_configs: {
		// This key should be used directly as a fancybox configuration object.
		// Structure must be same as: http://fancyapps.com/fancybox/#docs
		fancybox: {
			// Should display infobar (counter and arrows at the top)
			infobar: false,

			// What buttons should appear in the top right corner.
			// Buttons will be created using templates from `btnTpl` option
			// and they will be placed into toolbar (class="fancybox-toolbar"` element)
			// Possible options: slideShow', 'fullScreen', 'thumbs', 'close'
			buttons: [
				'slideShow',
				'fullScreen',
				'close',
			],
			animationEffect: 'fade',

			// Base template for layout

			// Internationalization
			lang: 'de',
			i18n: {
				'de': {
					CLOSE: 'Schliessen',
					PREV: 'vorheriges',
					NEXT: 'nächstes',
					ERROR: 'Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.', // eslint-disable-line max-len
					PLAY_START: 'Diaschau starten',
					PLAY_STOP: 'Diaschau beenden',
					FULL_SCREEN : 'Vollbild',
					THUMBS : 'Vorschaubilder',
					DOWNLOAD : 'Herunterladen',
					SHARE: 'Teilen',
					ZOOM: 'Maßstab',
				},
			},
		},
	},
	_eventNames: {
		CLICK: 'click',
	},
	_selectors: {},
	_stateClasses: {
		isBlocked: 'o-page--is-blocked',
		showOffcanvas: 'o-page--show-offcanvas',
	},
	start: function(resolve) {
		this.$ctx = $(this._ctx);

		// initialize breakpoint value
		this.breakpoint = this.getBreakpoint();

		// init optimized resize
		this.throttle('resize', 'optimizedResize');
		$(window).on('optimizedResize', this.$onOptimizedResize.bind(this));

		// init optimized scroll
		this.throttle('scroll', 'optimizedScroll');
		$(window).on('optimizedScroll', this.$onOptimizedScroll.bind(this));

		// We're using the default options: https://fancyapps.com/fancybox/3/docs/#options
		// Example: Init fancybox with adding "[data-fancybox]" attribute to the trigger element
		// Use our custom configuration for change the settings globally
		$.fancybox.defaults = $.extend($.fancybox.defaults, this._configs.fancybox);

		this._events.on('toggleOffcanvas', () => {
			this.onToggleOffcanvas();
		});

		this._events.on('scrollToTop', () => {
			this.scrollToTop();
		});

		this._events.on('toggleBlockPage', () => {
			this.onToggleBlockPage();
		});

		resolve();
	},
	stop: function() {
		// optional -> tidy up your module. Called on application.stop()
		// e.g. this._events.disconnect(); -> disconnect from the event dispatcher
	},

	getBreakpoint() {
		// read out the content of the bodies ::before-pseudo-element
		// source: https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript
		return window.getComputedStyle(this._ctx, ':before').getPropertyValue('content').replace(/["']/g, ''); // eslint-disable-line max-len
	},

	throttle(type, name, obj) {
		obj = obj || window;
		let running = false;
		const func = function() {
			if (running) { return; }
			running = true;
			requestAnimationFrame(() => { // eslint-disable-line no-undef
				obj.dispatchEvent(new CustomEvent(name)); // eslint-disable-line no-undef
				running = false;
			});
		};
		obj.addEventListener(type, func);
	},

	$onOptimizedScroll(ev) {
		this._events.emit('windowScroll', {
			ev,
		});
	},

	$onOptimizedResize(ev) {
		this._events.emit('windowResize', {
			ev,
		});

		const breakpoint = this.getBreakpoint();

		if (breakpoint !== this.breakpoint) {
			this._events.emit('breakpointChange', {
				breakpoint,
			});
			this.breakpoint = breakpoint;
		}
	},

	onToggleOffcanvas() {
		this.$ctx = $(this._ctx);

		this.$ctx.toggleClass(this._stateClasses.showOffcanvas);
	},

	onToggleBlockPage() {
		this.$ctx = $(this._ctx);

		this.$ctx.toggleClass(this._stateClasses.isBlocked);
	},

	scrollToTop() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	},
});

export default T.Module.Page;
